/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskProfileSummary } from './RiskProfileSummary';
import {
  RiskProfileSummaryFromJSON,
  RiskProfileSummaryFromJSONTyped,
  RiskProfileSummaryToJSON,
} from './RiskProfileSummary';

/**
 *
 * @export
 * @interface PaginatedRiskProfileSummaryList
 */
export interface PaginatedRiskProfileSummaryList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRiskProfileSummaryList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileSummaryList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRiskProfileSummaryList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RiskProfileSummary>}
   * @memberof PaginatedRiskProfileSummaryList
   */
  results: Array<RiskProfileSummary>;
}

/**
 * Check if a given object implements the PaginatedRiskProfileSummaryList interface.
 */
export function instanceOfPaginatedRiskProfileSummaryList(value: object): value is PaginatedRiskProfileSummaryList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRiskProfileSummaryListFromJSON(json: any): PaginatedRiskProfileSummaryList {
  return PaginatedRiskProfileSummaryListFromJSONTyped(json, false);
}

export function PaginatedRiskProfileSummaryListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRiskProfileSummaryList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RiskProfileSummaryFromJSON),
  };
}

export function PaginatedRiskProfileSummaryListToJSON(value?: PaginatedRiskProfileSummaryList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RiskProfileSummaryToJSON),
  };
}
